// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hel-select legend,.hel-select .legend{position:relative;margin-top:1.5rem}.hel-select legend .validation-error-popover.popover.small,.hel-select .legend .validation-error-popover.popover.small{top:50%}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
